var Mediastar_NN = {
    name: "Mediastar NN",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [71,0,6,141,2,208,1,145,2,59,6,158,35,75,17,141,2,168,159,158,35,107,8,131,2,0,0,59,245,170,237,246,213,68,32,128],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [71,0,6,128,2,224,1,123,2,81,6,154,35,82,17,115,2,157,159,157,35,104,8,158,2,0,0,59,245,170,221,125,117,68,32,128],
        },
        {
            function: "KEY_DISPLAY",
            name: "KEY_DISPLAY",
            icon: "KEY_DISPLAY",
            command: [71,0,6,154,2,199,1,148,2,54,6,167,35,62,17,147,2,154,159,152,35,109,8,136,2,0,0,59,245,170,255,106,171,68,32,128],
        },
        {
            // function: "KEY_MODE",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [71,0,6,135,2,208,1,131,2,82,6,154,35,75,17,128,2,155,159,154,35,127,8,126,2,0,0,59,245,170,223,186,171,68,32,128],
        },
        {
            function: "KEY_TIMER",
            name: "KEY_TIMER",
            icon: "KEY_TIMER",
            command: [71,0,6,138,2,201,1,139,2,77,6,159,35,69,17,135,2,151,159,153,35,125,8,136,2,0,0,59,245,170,239,182,171,68,32,128],
        },
        {
            function: "KEY_TV/R",
            name: "KEY_TV/R",
            icon: "KEY_TV/R",
            command: [71,0,6,138,2,205,1,135,2,75,6,154,35,72,17,136,2,144,159,158,35,123,8,133,2,0,0,59,245,170,245,122,245,68,32,128],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [71,0,6,139,2,207,1,131,2,78,6,155,35,70,17,131,2,152,159,159,35,126,8,131,2,0,0,59,245,170,223,245,85,68,32,128],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [67,0,4,140,2,202,1,136,2,79,6,163,35,75,17,130,2,0,0,59,245,170,239,237,85,68],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [71,0,6,140,2,205,1,132,2,81,6,157,35,70,17,130,2,160,159,153,35,127,8,129,2,0,0,59,245,170,215,253,85,68,32,128],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [67,0,4,137,2,206,1,132,2,81,6,186,35,70,17,135,2,0,0,59,245,170,247,235,85,68],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [67,0,4,137,2,205,1,131,2,82,6,156,35,76,17,128,2,0,0,59,245,170,219,251,85,68],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [67,0,4,140,2,203,1,132,2,83,6,158,35,43,17,127,2,0,0,59,245,170,235,247,85,68],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [67,0,4,142,2,204,1,129,2,82,6,183,35,73,17,127,2,0,0,59,245,170,213,255,85,68],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [67,0,4,141,2,202,1,132,2,82,6,159,35,82,17,126,2,0,0,59,245,170,251,234,213,68],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [67,0,4,140,2,203,1,133,2,83,6,149,35,72,17,127,2,0,0,59,245,170,221,250,213,68],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [63,0,5,140,2,207,1,128,2,81,6,158,35,83,17,139,2,147,162,129,2,0,0,59,245,170,255,138,170,132],
        },
        {
            function: "KEY_SAT",
            name: "KEY_SAT",
            icon: "KEY_SAT",
            command: [67,0,4,135,2,208,1,132,2,82,6,156,35,70,17,127,2,0,0,59,245,170,238,246,181,68],
        },
        {
            function: "KEY_F1",
            name: "KEY_F1",
            icon: "KEY_F1",
            command: [67,0,4,139,2,201,1,136,2,82,6,157,35,76,17,130,2,0,0,59,245,170,218,190,245,68],
        },
        {
            function: "KEY_RECALL",
            name: "KEY_RECALL",
            icon: "KEY_RECALL",
            command: [67,0,4,134,2,205,1,132,2,84,6,155,35,69,17,128,2,0,0,59,245,170,214,183,187,68],
        },
        {
            function: "KEY_ZOOM",
            name: "KEY_ZOOM",
            icon: "KEY_ZOOM",
            command: [67,0,4,130,2,205,1,137,2,84,6,157,35,71,17,125,2,0,0,59,245,170,219,221,171,68],
        },
        {
            function: "KEY_MOTOR",
            name: "KEY_MOTOR",
            icon: "KEY_MOTOR",
            command: [67,0,4,136,2,201,1,137,2,83,6,176,35,76,17,125,2,0,0,59,245,170,251,181,107,68],
        },
        {
            function: "KEY_TXT",
            name: "KEY_TXT",
            icon: "KEY_TXT",
            command: [67,0,4,133,2,206,1,136,2,81,6,161,35,72,17,126,2,0,0,59,245,170,247,181,171,68],
        },
        {
            function: "KEY_FIND",
            name: "KEY_FIND",
            icon: "KEY_FIND",
            command: [67,0,4,133,2,208,1,133,2,83,6,145,35,75,17,131,2,0,0,59,245,170,253,181,91,68],
        },
        {
            function: "KEY_EPG",
            name: "KEY_EPG",
            icon: "KEY_EPG",
            command: [67,0,4,135,2,207,1,133,2,84,6,152,35,74,17,124,2,0,0,59,245,170,213,191,181,68],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [67,0,4,139,2,203,1,134,2,84,6,151,35,71,17,125,2,0,0,59,245,170,235,187,173,68],
        },
        {
            function: "KEY_SLEEP",
            name: "KEY_SLEEP",
            icon: "KEY_SLEEP",
            command: [67,0,4,131,2,207,1,134,2,84,6,149,35,78,17,125,2,0,0,59,245,170,215,111,91,68],
        },
        {
            function: "KEY_RED",
            name: "KEY_RED",
            icon: "KEY_RED",
            command: [67,0,4,132,2,206,1,134,2,85,6,152,35,69,17,124,2,0,0,59,245,170,222,221,91,68],
        },
        {
            function: "KEY_GREEN",
            name: "KEY_GREEN",
            icon: "KEY_GREEN",
            command: [67,0,4,133,2,204,1,135,2,84,6,156,35,71,17,127,2,0,0,59,245,170,238,219,91,68],
        },
        {
            function: "KEY_YELLOW",
            name: "KEY_YELLOW",
            icon: "KEY_YELLOW",
            command: [67,0,4,128,2,211,1,132,2,86,6,153,35,71,17,123,2,0,0,59,245,170,219,110,219,68],
        },
        {
            function: "KEY_BLUE",
            name: "KEY_BLUE",
            icon: "KEY_BLUE",
            command: [67,0,4,134,2,206,1,135,2,85,6,186,35,62,17,132,2,0,0,59,245,170,235,109,219,68],
        },
        {
            function: "KEY_FAV",
            name: "KEY_FAV",
            icon: "KEY_FAV",
            command: [67,0,4,133,2,207,1,132,2,83,6,154,35,81,17,125,2,0,0,59,245,170,246,245,181,68],
        },
        {
            function: "KEY_SUB",
            name: "KEY_SUB",
            icon: "KEY_SUB",
            command: [67,0,4,133,2,205,1,136,2,84,6,175,35,83,17,125,2,0,0,59,245,170,250,218,187,68],
        },
        {
            function: "KEY_MENU",
            name: "KEY_MENU",
            icon: "KEY_MENU",
            command: [67,0,4,133,2,208,1,132,2,84,6,158,35,77,17,125,2,0,0,59,245,170,235,123,181,68],
        },
        {
            // function: "KEY_EXIT",
            function: "KEY_BACK",
            name: "KEY_BACK",
            icon: "KEY_BACK",
            command: [67,0,4,137,2,205,1,130,2,83,6,189,35,75,17,125,2,0,0,59,245,170,213,95,245,68],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [67,0,4,132,2,205,1,135,2,85,6,155,35,80,17,125,2,0,0,59,245,170,214,254,213,68],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [67,0,4,140,2,205,1,130,2,81,6,161,35,45,17,128,2,0,0,59,245,170,213,127,213,68],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [67,0,4,137,2,209,1,131,2,83,6,187,35,79,17,131,2,0,0,59,245,170,234,251,213,68],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [67,0,4,138,2,205,1,132,2,79,6,157,35,49,17,134,2,0,0,59,245,170,245,245,213,68],
        },
        {
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [67,0,4,139,2,205,1,133,2,80,6,146,35,82,17,132,2,0,0,59,245,170,218,253,213,68],
        },
        {
            function: "KEY_CHANNELUP",
            name: "KEY_CHANNELUP",
            icon: "KEY_CHANNELUP",
            command: [67,0,4,134,2,205,1,136,2,81,6,151,35,74,17,135,2,0,0,59,245,170,246,218,219,68],
        },
        {
            function: "KEY_CHANNELDOWN",
            name: "KEY_CHANNELDOWN",
            icon: "KEY_CHANNELDOWN",
            command: [67,0,4,136,2,204,1,135,2,80,6,154,35,72,17,132,2,0,0,59,245,170,213,183,219,68],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [67,0,4,136,2,207,1,135,2,76,6,148,35,70,17,130,2,0,0,59,245,170,254,234,173,68],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [67,0,4,137,2,204,1,137,2,77,6,158,35,77,17,130,2,0,0,59,245,170,223,122,173,68],
        },
        {
            function: "KEY_HD",
            name: "KEY_HD",
            icon: "KEY_HD",
            command: [67,0,4,137,2,203,1,135,2,78,6,159,35,68,17,134,2,0,0,59,245,170,215,222,171,68],
        },
        {
            function: "KEY_USB",
            name: "KEY_USB",
            icon: "KEY_USB",
            command: [67,0,4,136,2,202,1,136,2,81,6,156,35,73,17,133,2,0,0,59,245,170,214,239,107,68],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [67,0,4,138,2,203,1,135,2,77,6,185,35,82,17,134,2,0,0,59,245,170,253,234,181,68],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [67,0,4,133,2,201,1,141,2,79,6,154,35,78,17,132,2,0,0,59,245,170,219,125,181,68],
        },
        {
            function: "KEY_PREVIOUS",
            name: "KEY_PREVIOUS",
            icon: "KEY_PREVIOUS",
            command: [67,0,4,138,2,203,1,138,2,78,6,154,35,75,17,130,2,0,0,59,245,170,222,250,181,68],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [67,0,4,133,2,207,1,130,2,83,6,187,35,82,17,128,2,0,0,59,245,170,235,219,171,68],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [67,0,4,132,2,208,1,135,2,84,6,153,35,81,17,125,2,0,0,59,245,170,237,123,117,68],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [67,0,4,136,2,207,1,130,2,84,6,158,35,69,17,123,2,0,0,59,245,170,234,189,245,68],
        },
        {
            function: "KEY_RECORD",
            name: "KEY_RECORD",
            icon: "KEY_RECORD",
            command: [67,0,4,130,2,211,1,131,2,84,6,182,35,83,17,125,2,0,0,59,245,170,215,126,181,68],
        },
        {
            function: "KEY_F2",
            name: "KEY_F2",
            icon: "KEY_F2",
            command: [67,0,4,134,2,206,1,134,2,85,6,156,35,49,17,124,2,0,0,59,245,170,239,118,173,68],
        },
        {
            function: "KEY_F3",
            name: "KEY_F3",
            icon: "KEY_F3",
            command: [67,0,4,131,2,209,1,132,2,84,6,160,35,83,17,125,2,0,0,59,245,170,215,190,173,68],
        },
        {
            function: "KEY_F4",
            name: "KEY_F4",
            icon: "KEY_F4",
            command: [67,0,4,131,2,207,1,135,2,86,6,149,35,79,17,124,2,0,0,59,245,170,247,117,173,68],
        },
        {
            function: "KEY_F5",
            name: "KEY_F5",
            icon: "KEY_F5",
            command: [67,0,4,130,2,206,1,135,2,86,6,155,35,84,17,126,2,0,0,59,245,170,219,189,173,68],
        },
    ]
}
export default Mediastar_NN